exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-2a9ea794]{margin-bottom:20px}\n", ""]);

// exports
